import DOMPurify from 'dompurify'
import { API_BASE, apiSlice } from '@/redux/api-slice'

const url = API_BASE + 'WhatsNew/'

const whatsNewApi = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getWhatsNewText: build.query<string, void>({
      query: () => ({
        url: url,
        responseHandler: (response: Response) => response.text(),
      }),
      transformResponse: (response: string) => {
        return DOMPurify.sanitize(response)
      },
    }),
    getHeaderMessage: build.query<string, void>({
      query: () => ({
        url: url + 'Header',
        responseHandler: (response: Response) => response.text(),
      }),
      transformResponse: (response: string) => {
        return DOMPurify.sanitize(response)
      },
    }),
  }),
})

export const { useLazyGetWhatsNewTextQuery, useLazyGetHeaderMessageQuery } =
  whatsNewApi
